import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FolderWizard from './FolderWizard';
import { loadFolderHeader } from '../actionCreators';
import { loadFolderHeaderAlpha } from '../actionCreatorsAlpha';
import { getInt } from 'utils/functions';
import { getFolderHeader, getFolderGeneralInfo } from '../selectors';
import documentTypeIds from 'constants/documentTypeIds';
import {
  view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7,
  view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40,
  view_34469723_3B6D_44AD_8387_A099FC22956B
} from 'constants/viewType';
import { loadDocumentSecurity } from 'features/document/edit/documents/actionCreators';

export const FolderWizardRouteContainer = props => {
  const { match, history, folderHeader, actions, location, generalInfo, viewType } = props;
  const [access, setAccess] = useState(true);

  const documentId = getInt(match.params.documentId);
  const siteId = getInt(match.params.siteId);

  const isNewFolder = match.params.newFolder && match.params.newFolder === 'new';
  const isNewFacilityApproval = match.params.newFacilityApproval === 'facilityApproval';

  let firstUpdate = useRef(false);

  const loadAccess = useCallback(
    async (documentId, siteId) => {
      if (!documentId || !siteId) return;
      const accessResult = await actions.loadDocumentSecurity(documentId, siteId);
      if (accessResult) setAccess(accessResult.access);
    },
    [actions]
  );

  useEffect(() => {
    loadAccess(documentId, siteId);

    firstUpdate.current = true;
    return () => (firstUpdate.current = false);
  }, [documentId, siteId, loadAccess]);

  useEffect(() => {
    if ((!isNewFolder || !isNewFacilityApproval) && access === false) {
      history.push('/notAllowed');
    }
  }, [access, history, isNewFolder, isNewFacilityApproval]);

  useEffect(() => {
    if (isNewFolder || isNewFacilityApproval || viewType === undefined || viewType === null) return;

    if (firstUpdate.current || !folderHeader.loaded) {
      if (
        viewType === view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7 ||
        viewType === view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40 ||
        viewType === view_34469723_3B6D_44AD_8387_A099FC22956B
      )
        actions.loadFolderHeaderAlpha(documentId, siteId);
      else actions.loadFolderHeader(documentId, siteId);
    }
  }, [documentId, siteId, folderHeader.loaded, actions, isNewFacilityApproval, isNewFolder, viewType]);

  return (
    (isNewFolder || isNewFacilityApproval || folderHeader.documentId) &&
    !generalInfo.loading && (
      <FolderWizard
        documentId={documentId}
        siteId={siteId}
        isNewFolder={isNewFolder}
        isNewFacilityApproval={isNewFacilityApproval}
        folderHeader={folderHeader}
        history={history}
        locationPathName={location.pathname}
        generalInfo={generalInfo}
      />
    )
  );
};

function mapStateToProps(state, ownProps) {
  const { match } = ownProps;
  let docTypeId = match.params.newFacilityApproval === 'facilityApproval' ? documentTypeIds.FacilityApproval : documentTypeIds.Folder;
  return {
    folderHeader: getFolderHeader(state, docTypeId),
    generalInfo: getFolderGeneralInfo(state),
    viewType: state.params.items.viewType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadFolderHeader,
        loadFolderHeaderAlpha,
        loadDocumentSecurity
      },
      dispatch
    ),
    dispatch
  };
}

FolderWizardRouteContainer.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object,
  history: PropTypes.object.isRequired,
  folderHeader: PropTypes.object,
  actions: PropTypes.object.isRequired,
  viewType: PropTypes.string,
  generalInfo: PropTypes.object
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(withRouter(FolderWizardRouteContainer));
